import { render, staticRenderFns } from "./NhZzfBigScreen.vue?vue&type=template&id=351f0198&"
import script from "./NhZzfBigScreen.vue?vue&type=script&lang=js&"
export * from "./NhZzfBigScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports